import React, { useState } from 'react';
import componentStyles from './gameLogs.module.css';

const GameLogs = ({inDepthBetCardTeamStats, inDepthBetCardMatchupInsights, sportType}) => {
    const [activeTeam, setActiveTeam] = useState(Object.keys(inDepthBetCardTeamStats)[0]);
    const [showFullStats, setShowFullStats] = useState(false);

    // Helper function to get color for ATS/Totals results
    const getResultColor = (result) => {
        if (result === 'W' || result === 'OVER') {
            return 'var(--bloomberg-green)';
        } else if (result === 'L' || result === 'UNDER') {
            return 'var(--bloomberg-red)';
        }
        return 'var(--bloomberg-orange)'; // For Push or other neutral results
    };

    // Helper function to format table data for better display
    const formatTableCell = (key, value) => {
        // Check if this is a result column that needs color coding
        if (key.toLowerCase().includes('ats') || key.toLowerCase().includes('total') || key.toLowerCase().includes('result')) {
            return (
                <span 
                    className={componentStyles.resultCell}
                    style={{ color: getResultColor(value) }}
                >
                    {value}
                </span>
            );
        }
        
        // Check if this is a score column
        if (key.toLowerCase().includes('score') || key.toLowerCase().includes('points')) {
            return <span className={componentStyles.scoreCell}>{value}</span>;
        }
        
        // Default formatting
        return <span className={componentStyles.defaultCell}>{value}</span>;
    };

    const displayTeamSelector = () => {
        const teamNames = Object.keys(inDepthBetCardTeamStats);
        const teamSelectorButtons = teamNames.map((teamName) => {
            const isActive = activeTeam === teamName;
            return (
                <button 
                    key={teamName}
                    className={`${componentStyles.teamSelectorButton} ${isActive ? componentStyles.teamSelectorButtonActive : ''}`}
                    onClick={() => setActiveTeam(teamName)}
                >
                    {teamName}
                </button>
            );
        });
        
        return (
            <div className={componentStyles.teamSelector}>
                <h3>Team Selector</h3>
                <div className={componentStyles.teamSelectorButtons}>
                    {teamSelectorButtons}
                </div>
            </div>
        );
    };

    const getColumns = () => {

    }

    const displayGameLogsTable = () => {
        if (!inDepthBetCardTeamStats || !inDepthBetCardTeamStats[activeTeam]) {
            return (
                <div className={componentStyles.noDataMessage}>
                    No data available for {activeTeam}
                </div>
            );
        }

        const columnNames = Object.keys(inDepthBetCardTeamStats[activeTeam][0]);
        const columnRows = Object.values(inDepthBetCardTeamStats[activeTeam]);

        const tableHeader = columnNames.map((columnName) => {
            return (
                <th key={columnName} className={componentStyles.tableHeader}>
                    {columnName.replace(/([A-Z])/g, ' $1').trim()}
                </th>
            );
        });

        const tableRows = columnRows.map((columnRow, columnRowIndex) => {   
            return (
                <tr key={columnRowIndex} className={componentStyles.tableRow}>
                    {Object.entries(columnRow).map(([key, value]) => {
                        return (
                            <td key={`${columnRowIndex}-${key}`} className={componentStyles.tableCell}>
                                {formatTableCell(key, value)}
                            </td>
                        );
                    })}
                </tr>
            );
        });

        return (
            <div className={componentStyles.tableContainer}>
                <div className={componentStyles.tableWrapper}>
                    <table className={componentStyles.gameLogsTable}>
                        <thead>
                            <tr>{tableHeader}</tr>
                        </thead>
                        <tbody>{tableRows}</tbody>
                    </table>
                </div>
            </div>
        );
    };

    const displayMatchupInsights = () => {
        if (!inDepthBetCardMatchupInsights) return null;

        return (
            <div className={componentStyles.matchupInsights}>
                <h3>Matchup Insights</h3>
                <div className={componentStyles.insightsGrid}>
                    <div className={componentStyles.insightItem}>
                        <span className={componentStyles.insightLabel}>Record:</span>
                        <span className={componentStyles.insightValue}>{inDepthBetCardMatchupInsights.record}</span>
                    </div>
                    <div className={componentStyles.insightItem}>
                        <span className={componentStyles.insightLabel}>Score Avg:</span>
                        <span className={componentStyles.insightValue}>{inDepthBetCardMatchupInsights.scoreAvg}</span>
                    </div>
                    <div className={componentStyles.insightItem}>
                        <span className={componentStyles.insightLabel}>Totals Avg:</span>
                        <span className={componentStyles.insightValue}>{inDepthBetCardMatchupInsights.totalsAvg}</span>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className={componentStyles.gameLogsContainer}>
            <div className={componentStyles.gameLogsHeader}>
                <h2>Game Logs</h2>
                {displayTeamSelector()}
            </div>
            {/* {displayMatchupInsights()} */}
            {displayGameLogsTable()}
        </div>
    );
};

export default GameLogs;
